export default "__VITE_ASSET__DYWiiPXN__"